module.exports = __webpack_public_path__ + "static/img/5.873b931.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/8/zh/5.png
// module id = z1fo
// module chunks = 0